import EmployeeTrainingList from './EmployeeTrainingList';

export default EmployeeTrainingList;
